// extracted by mini-css-extract-plugin
export var standaloneTable = "_1q-0";
export var standaloneTableWithBodyFill = "_1q-1";
export var withExtraHeader = "_1q-2";